/**
 * Determines the appropriate text color based on the background color.
 * Returns white text color for black backgrounds to ensure readability.
 * 
 * @param {string} backgroundColor - The background color (hex, rgb, or named color)
 * @returns {string|undefined} - The text color to use, or undefined to use default
 */
export function getTextColorForBackground(backgroundColor) {
  if (!backgroundColor) return undefined;
  
  // Normalize the color value for comparison
  const normalizedColor = backgroundColor.toLowerCase().trim();
  
  // Check for black backgrounds
  if (normalizedColor === "#000000" || normalizedColor === "black" || normalizedColor === "rgb(0, 0, 0)") {
    return "#FFFFFF";
  }
  
  return undefined;
}

/**
 * Returns a style object with backgroundColor and appropriate text color.
 * Useful for inline styles on account badges and similar components.
 * 
 * @param {string} backgroundColor - The background color
 * @param {object} additionalStyles - Any additional style properties to merge
 * @returns {object} - Style object with backgroundColor and color
 */
export function getAccountBadgeStyles(backgroundColor, additionalStyles = {}) {
  return {
    backgroundColor,
    color: getTextColorForBackground(backgroundColor),
    ...additionalStyles,
  };
}
